<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a href="/" title="Home">Home</a>
            </li>
            <li class="breadcrumb-item">
                <a href="/recipes" title="Our Recipes">Our Recipes</a>
            </li>
            <li class="breadcrumb-item">
                <a href="/categories" title="Recipe Categories"
                    >Recipe Categories</a
                >
            </li>
            <li class="breadcrumb-item">
                <a
                    class="breadcrumb-category"
                    :href="'/categories/' + category.slug"
                    :title="category.name"
                    v-for="category in categories"
                    :key="category.id"
                    >Category: {{ category.name }}</a
                >
            </li>
            <li
                class="breadcrumb-item active"
                aria-current="page"
                :title="recipe_name"
            >
                {{ recipe_name }}
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    name: "RecipeBreadCrumbs",
    props: ["recipe"],
    data() {
        return {
            categories: this.recipe.categories,
            recipe_name: this.recipe.name,
            recipe_slug: this.recipe.slug,
        };
    },
};
</script>
<style scoped>
.breadcrumb-category {
    margin-right: 0.5em;
}
</style>
